import MainHeading from "@/components/common/MainHeading"
import Layout from "@/components/layout/Layout"
import ShiftAndTimeService from "@/services/ShiftAndTime/ShiftAndTime"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ThrowError } from "@/api/callApi"
import { showToastNotification } from "@/utility/helper"
import type { TableColumn } from "@/components/common/CommonTable"
import { Button } from "@/components/ui/button"
import { RoutesLink } from "@/utility/RouteLinks"
import { Pencil, Plus, Trash, TriangleAlert } from "lucide-react"
import CommonTable from "@/components/common/CommonTable"
import CommonModal from "@/components/common/CommonModal"
import type { shiftAndTime } from "@/interface/shiftAndTime.interface"

const ShiftAndTime: React.FC = () => {
    const navigate = useNavigate()
    const [shiftAndTime, setShiftAndTime] = useState<shiftAndTime[]>([]);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteId, setDeleteId] = useState<string>("");
    console?.log("shiftAndTime", shiftAndTime)

    const handleGetShiftAndTime = async () => {
        try {
            const response = await ShiftAndTimeService?.getShiftAndTime();
            if (response?.status) {
                setShiftAndTime(response?.data?.shift)
                // setDepartment(Array.isArray(response.data) ? response.data : []);
            }
            console.log("response", response)
        } catch (error) {
            ThrowError(error)
        }
    }


    const handleDeleteShiftAndTime = async () => {
        try {
            const response = await ShiftAndTimeService?.deleteShiftAndTime(deleteId);
            if (response?.status) {
                showToastNotification("success", response?.message)
                toggleDeleteDialog("")
                handleGetShiftAndTime();
            } else {
                showToastNotification("danger", response?.message)
            }
        } catch (error) {
            ThrowError(error)
        }
    }
    useEffect(() => {
        handleGetShiftAndTime();
    }, []);

    const toggleDeleteDialog = (id: string | undefined) => {
        setDeleteId(id ?? "");
        setDeleteDialogOpen(!deleteDialogOpen);
    }
    const columns: TableColumn<shiftAndTime>[] = [
        {
            key: 'srNo',
            header: 'Sr No',
            render: (_item: shiftAndTime, index: number) => (
                <span className="text-muted-foreground font-medium"># {index + 1}</span>
            )
        },
        {
            key: 'departmentName',
            header: 'Department Name',
            render: (item: shiftAndTime) => (
                <span className="font-semibold capitalize">{item?.shiftName}</span>
            )
        },
        {
            key: 'startTime',
            header: 'Start Time',
            render: (item: shiftAndTime) => (
                <span className="font-semibold capitalize">{item?.startTime}</span>
            )
        },
        {
            key: 'endTime',
            header: 'End Time',
            render: (item: shiftAndTime) => (
                <span className="font-semibold capitalize">{item?.endTime}</span>
            )
        },
        {
            key: 'checkInBufferTime',
            header: 'Check-in Buffer',
            render: (item: shiftAndTime) => (
                <span className="font-semibold capitalize">{item?.checkInBufferTime}</span>
            )
        },
        {
            key: 'checkOutBufferTime',
            header: 'Check-out Buffer',
            render: (item: shiftAndTime) => (
                <span className="font-semibold capitalize">{item?.checkOutBufferTime}</span>
            )
        },
        {
            key: 'type',
            header: 'Type',
            render: (item: shiftAndTime) => (
                <span className="font-semibold capitalize">{item?.type}</span>
            )
        },
        // {
        //     key: 'status',
        //     header: 'Status',
        //     render: (item: shiftAndTime) => (
        //         <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded-full ${item?.isActive ? 'text-green-600 border-green-600 bg-green-50' : 'text-destructive border-destructive bg-destructive/10'}`}>
        //             {item?.isActive ? 'Active' : 'Inactive'}
        //         </span>
        //     )
        // },
        {
            key: 'actions',
            header: 'Actions',
            render: (item: shiftAndTime) => (
                <div className="flex gap-2">
                    <Button
                        size={'icon'}
                        onClick={() => navigate(`${RoutesLink.editShiftAndTime}/${item?.id}`)}
                        className="bg-primary/10 text-primary hover:bg-primary/20"
                        title="Edit Department"
                    >
                        <Pencil size={18} />
                    </Button>
                    <Button
                        size={'icon'}
                        onClick={() => toggleDeleteDialog(item?.id)}
                        className="bg-destructive/10 text-destructive hover:bg-destructive/20"
                        title="Delete Department"
                    >
                        <Trash size={18} />
                    </Button>
                </div>
            ),
        },
    ]
    return (
        <>
            <Layout>
                <div className="space-y-6">
                    <MainHeading title="Shift and Time" isBackButtonVisible={true} buttonText='Add Shift and Time'
                        buttonIcon={<Plus />}
                        onClick={() => { navigate(RoutesLink.addShiftAndTime) }} />
                    <CommonTable data={shiftAndTime} columns={columns} />

                </div>
            </Layout>

            <CommonModal
                title=""
                show={deleteDialogOpen}
                onClose={() => toggleDeleteDialog("")}
                className="max-w-md rounded-2xl p-0 overflow-hidden"
            >
                <div className="p-6">
                    <div className="flex flex-col items-center text-center">
                        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
                            <TriangleAlert className="text-red-600 w-8 h-8" />
                        </div>

                        <h2 className="mt-5 text-2xl font-bold text-gray-900">
                            Delete Department?
                        </h2>

                        <p className="mt-3 text-sm leading-6 text-gray-500">
                            This action cannot be undone. Once deleted, all department data will be
                            permanently removed from our servers.
                        </p>
                    </div>

                    <div className="mt-8 flex gap-3">
                        <Button
                            variant="outline"
                            className="flex-1"
                            onClick={() => toggleDeleteDialog("")}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="destructive"
                            className="flex-1"
                            onClick={handleDeleteShiftAndTime}
                        >
                            Delete
                        </Button>
                    </div>
                </div>
            </CommonModal>
        </>
    )
}

export default ShiftAndTime